import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';
import { Address } from '../common/address';
import { WithCustomFields } from '../custom_field/customField';
import { applyMixins } from '../../util/mixins';

export class Contact extends CompanyEntity {
  name!: string;
  addresses?: Address[] = [];
  emails?: string[] = [];
  phones?: string[] = [];

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }
}

export interface Contact extends WithCustomFields {}
applyMixins(Contact, [Contact, WithCustomFields]);
